import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = (isOSOnDarkMode, explicitScheme) => {
  if (explicitScheme) {
    LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, explicitScheme);
  }
  const selectedColorScheme =
    explicitScheme || LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  // eslint-disable-next-line no-console
  console.log('[THEME DEBUG] setColorTheme called', {
    isOSOnDarkMode,
    explicitScheme,
    localStorageValue: LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME),
    selectedColorScheme,
    stack: new Error().stack,
  });
  if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    document.body.classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.body.classList.remove('dark');
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
